<template>
  <div class="opera-revenueState">
   
    <topNav  :title="$t('revenueReport_title')"></topNav>
   <div class="topfix">
     <div class="fixc">
    <datepik @change='getDate' ref="datepik" limit="pre" step="1"></datepik>
      <div class="tags clearfix" >
        <div style="width: 3000px">
            <div class="tag" @click="getList(7)" :class="{active:index==7}">
          Revenue
          </div>
          <div class="tag" @click="getList(1)" :class="{active:index==1}">
           Salesroom
          </div>
          <div class="tag" @click="getList(2)" :class="{active:index==2}">
            In-House Guest
          </div>
          <div class="tag" @click="getList(3)" :class="{active:index==3}">
           Arrival
          </div>
          <div class="tag" @click="getList(4)" :class="{active:index==4}">
          Departure
          </div>
          <div class="tag" @click="getList(5)" :class="{active:index==5}">
           No Show
          </div>
           <div class="tag" @click="getList(6)" :class="{active:index==6}">
           Room Status
          </div>
         
           <div class="tag" @click="getList(8)" :class="{active:index==8}">
          Arrival And Departure for Tomorrow
          </div>
           <div class="tag" @click="getList(9)" :class="{active:index==9}">
         Occupancy
          </div>
        </div>
      </div>
       <div class="formTop"
         :class='{formTopFix:formPosition==true}'>
      <div class="topOne wt"
           style='text-align: left;'><span class="firstTh">{{$t('revenueReport_project')}}</span></div>
      <div class="topOne wd"><span>{{$t('revenueReport_daily')}}</span></div>
      <div class="topOne wm"><span>{{$t('revenueReport_month')}}</span></div>
      <div class="topOne wy"><span>{{$t('revenueReport_year')}}</span></div>
    </div>
     </div>
    </div>
    <div class="tc2">
     <table style="border-collapse:collapse;width: 100%;table-layout: fixed;"
             class="tbodyH">
        <tr>
          <th class="wt"></th>
          <th class="wd"></th>
          <th class="wm"></th>
          <th class="wy"></th>
        </tr>
          <tr v-for="item in reportInfo2" :key="item.code" :class="{red:item.sub==1}">
            <td class="title" >
                {{item.descript}}
           </td>
            <td>
              {{item.amount | toThousands}}
            </td>
            <td>
                {{item.amount_m | toThousands}}
            </td>
            <td class="br">
                {{item.amount_y | toThousands}}
            </td>
          </tr>
</table>
</div>
    <nothing :condition="reportInfo != null && reportInfo.length == 0"  :dis="$t('revenueReport_nothing')"></nothing>

  </div>
</template>
<script>
  import datepik from "../operaCommon/datepik";
  import moment from "moment";
  import nothing from "../operaCommon/nothing";
  import _ from "lodash";
  import {Toast} from "mint-ui";

  export default {
    data() {
      return {
        reportInfo: {},
        reportInfo2:[],
        index:7,
        Report: {
          code: "", //酒店范围代码（空时取当前）
          d: null, //日期（空时当前营业日）
          level: "", //酒店范围代码（可空）
          name: "" //i酒店范围的名称
        },
        hotelName: "",
        showRevenueState: false,
        showHotelList: false,
        formPosition: false //默认tab不固定
      };
    },
    mounted() {
      this.getRevenue();

    },
    methods: {
      getList(i){
        this.index = i;
          this.setData();
      },

      setData(){
        this.reportInfo2=[];
          this.reportInfo.forEach(e => {
            if(this.index == 1){
                if(e.code == "PHYSICAL_ROOMS" || e.code == "OCC_ROOMS" || e.code == "PHYSICAL_ROOMS_MINUS_OOO" || e.code == "AVAIL_ROOMS"
                || e.code == "AVAIL_ROOMS_MINUS_OOO" || e.code == "COMP_ROOMS" || e.code == "HOUSE_USE_ROOMS" || e.code == "OCC_MINUS_COMP_HU" 
                || e.code == "OCC_MINUS_COMP" || e.code == "DAYUSE_ROOMS" || e.code == "OOO_ROOMS" || e.code == "OOS_ROOMS"){
                  this.reportInfo2.push(e);
                }
            }
            else if(this.index == 2){
                if(e.code == "ADULTS_IN_HOUSE" || e.code == "CHILDREN_IN_HOUSE" || e.code == "GUEST_IN_HOUSE" || e.code == "FIT_GUESTS_TODAY"
                || e.code == "GROUP_PERSONS" || e.code == "MEM_INHOUSE_PERSONS" || e.code == "VIP_GUESTS" || e.code == "FIT_ROOMS_TODAY" 
                || e.code == "GROUP_ROOMS" || e.code == "SOURCE_ROOMS_TODAY" || e.code == "COMPANY_ROOMS_TODAY" || e.code == "AGENT_ROOMS_TODAY"
                || e.code == "GROUP_ROOMS_TODAY" || e.code == "NO_OF_GROUPS" || e.code == "BIRTHDAYS" || e.code == "OCC_PERC" 
                || e.code == "OCC_PERC_WO_CH" || e.code == "OCC_PERC_WO_CHO" || e.code == "OCC_PERC_WO_C" || e.code == "OCC_PERC_WO_H"
                || e.code == "OCC_PERC_WO_CO" || e.code == "OCC_PERC_WO_HO" || e.code == "OCC_PERC_WO_O" ){
                  this.reportInfo2.push(e);
                }
            }
                else if(this.index == 3){
                if(e.code == "ARRIVAL_ROOMS" || e.code == "ARRIVAL_PERSONS" || e.code == "DEF_ARRIVALS_TODAY" || e.code == "TNT_ARRIVALS_TODAY"
                || e.code == "WALKIN_ROOMS" || e.code == "WALKIN_PERSONS" ){
                  this.reportInfo2.push(e);
                }
            }
            else if(this.index == 4){
                if(e.code == "EXT_STAY_ROOMS" || e.code == "EXT_STAY_PERSONS" || e.code == "DEPARTURE_ROOMS" || e.code == "DEPARTURE_PERSONS"
                || e.code == "EARLY_DEP_ROOMS" || e.code == "EARLY_DEP_PERSONS" || e.code == "FIT_DEPARTURE_ROOMS" || e.code == "FIT_DEPARTURE_PERSONS" 
                || e.code == "FIT_MEM_DEP_ROOMS" || e.code == "FIT_MEM_DEP_PERSONS" || e.code == "FIT_MEM_DEP_PERC" || e.code == "MEM_DEP_ROOMS"
                || e.code == "MEM_DEP_PERSONS" || e.code == "MEM_DEP_PERC" ){
                  this.reportInfo2.push(e);
                }
            }
            else if(this.index == 5){
                if(e.code == "NOSHOW_ROOMS" || e.code == "NOSHOW_PERSONS" || e.code == "CANCEL_RESERVATION" || e.code == "LATE_CANCEL_RES"
                || e.code == "RESERVATIONS" || e.code == "CANCELLATIONS_MADE_TODAY" || e.code == "ROOM_NGTS_RESERVED_TODAY" || e.code == "TODAY_DEMAND" 
                 ){
                  this.reportInfo2.push(e);
                }
            }
             else if(this.index == 6){
                if(e.code == "CLEAN_ROOMS" || e.code == "DIRTY_ROOMS_TODAY" || e.code == "DBLS_AS_SGLS_TODAY" || e.code == "BEDS_OCC_PERC"
                 ){
                  this.reportInfo2.push(e);
                }
            }
            else if(this.index == 7){
                if(e.code == "ADR_ROOM" || e.code == "ADR_ROOM_WO_C" || e.code == "ADR_ROOM_WO_H" || e.code == "ADR_ROOM_WO_CH"
                || e.code == "AVG_PERSONS_RATE" || e.code == "AVG_PERSONS_GROUP" || e.code == "AVG_REV_GROUP" || e.code == "AVG_ROOM_REV_GROUP" 
                || e.code == "ROOM_REVENUE" || e.code == "FOOD_BEV_REVENUE" || e.code == "OTHER_REVENUE" || e.code == "TOTAL_REVENUE"
                || e.code == "GROUP_REVENUE" || e.code == "GROUP_ROOM_REVENUE" || e.code == "FIT_REVENUE_TODAY" || e.code == "FIT_ROOM_REVENUE" 
                || e.code == "MEM_REVENUE_TODAY" || e.code == "MEM_REVENUE_NET" || e.code == "TOTAL_REVENUE_GUEST" || e.code == "PAYMENT"
                || e.code == "MAX_REVENUE_ALL_ROOMS" || e.code == "MAX_REVENUE_OCC_ROOMS" || e.code == "YIELD_ALL_ROOMS" 
                 || e.code == "YIELD_OCC_ROOMS" || e.code == "ARRIVAL_ROOMS_TOMORROW" ){
                   if(e.code == "TOTAL_REVENUE" || e.code == "ROOM_REVENUE" || e.code == "FOOD_BEV_REVENUE" || e.code == "OTHER_REVENUE"){
                     e.sub = 1;
                   }
                  this.reportInfo2.push(e);
                }
            }
            else if(this.index == 8){
                if(e.code == "ARRIVAL_ROOMS_TOMORROW" || e.code == "ARRIVAL_PERSONS_TOMORROW" || e.code == "DEPARTURE_ROOMS_TOMORROW"
                || e.code == "DEPARTURE_PERSONS_TOMORROW" || e.code == "OCC_PERC_TOMORROW"){
                  this.reportInfo2.push(e);
                }
            }
             else if(this.index == 9){
                if(e.code == "OCC_PERC_TOMORROW" || e.code == "OCC_PERC_MULTI" || e.code == "OCC_PERC_WEEK"){
                  this.reportInfo2.push(e);
                }
            }
      });

      },

      /*获取营收情况*/
      getRevenue() {
        this.$http
          .post("/mobilepmsapi/opera/report/getReport2", this.Report)
          .then(res => {
            if (res.data.result == 0) {
              this.reportInfo = res.data.retVal.data;
              this.setData();
              this.Report.d = moment(res.data.retVal.search.d).format(
                "YYYY-MM-DD"
              );
              this.$refs.datepik.setDate(
                moment(res.data.retVal.search.d).toDate()
              );
              this.hotelName = res.data.retVal.name;
            }
          });
      },
      getDate(time) {
        this.Report.d = time;
        // console.log(time)
        this.getRevenue();
      },
      getHotel(hotel) {
        this.Report.code = hotel.code;
        this.Report.level = hotel.level;
        this.Report.name = hotel.descript;
        // console.log(hotel.code)
        this.getRevenue();
      }
    },
    filters: {
      toThousands(num) {
        return ("" + num).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,");
      }
    },
    computed: {},
    components: {
      nothing,
      datepik
    }
  };
</script>
<style lang='less'>
  .opera-revenueState {
    background-color: #f6f8f9;
  height: 100vh;
  min-height: 100%;
  overflow: auto;
 
  .formTopFix {
    position: fixed;
    top: 1.04rem;
    z-index: 200;
  }
  .tc2{
        width: 100%;
     
      position: absolute;
      top: 4.4rem;
      height: ~"calc(100% - 4.4rem)";
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
  }
  .tbodyH {
    font-size: 0.32rem;
     td{
       text-align: right;
       margin-right:0.02rem;
     }
     .title{
       text-align:left;
       height:0.8rem;
       padding-left:0.1rem;
     }
     .br{padding-right: 0.1rem;}
     .red{
       color:red;
     }
  }
  .xsm {
    font-size: 0.28rem;
  }
  .chartform {
    width: 100%;
    margin: 0 auto;
    table {
      width: 100%;
      th {
        // height: 38px;
        color: #fff;
        background-color: #f69c2d;
        width: 20%;
      }
      .rtd {
        padding-right: 0.08rem;
      }
      .sub {
        .title {
          div {
            text-align: right;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      .nor {
        .title {
          div {
            font-weight: bold;
            text-align: left;
            padding-left: 0.1333rem;
          }
        }
      }
      .imp {
        color: red;
        .title {
          div {
            font-weight: bold;
            text-align: left;
          }
        }
      }
      td {
        // height: 0.6667rem;
        padding-left: 0.1333rem;
        text-align: right;
        width: 25%;

        div {
          padding: 0.1333rem 0.1rem 0.1333rem 0;
        }
        .icon-shangsheng {
          position: relative;
          left: -0.2667rem;
          line-height: 0.6667rem;
          color: #ff485f;
        }
        .icon-xiajiang {
          position: relative;
          left: -0.2667rem;
          line-height: 0.6667rem;
          color: #249f17;
        }
        .lf {
          text-align: left;
        }
      }
    }
  }
  .flip-list-enter {
    background-color: red;
  }
  .wt{
    width: 30% !important;
  }
  .wd {
    width: 20% !important;
  }
  .wm {
    width: 23% !important;
  }
  .wy {
    width: 27% !important;
  }

  
    .topfix{
     
      height: 3.27rem;
      top:1.04rem;
      left:0;
      background-color: #fff;
     z-index: 1;
     .fixc{
       display: inline;
     }
    .formTop {
    width: 100%;
    .topOne {
      width: 25%;
      height: 1.0133rem;
      color: #fff;
      background-color: #f69c2d;
      display: inline-block;
      text-align: right;
      line-height: 1.0133rem;
      float: left;
      font-weight: bold;
    }

    span {
      padding-right: 0.2rem;
    }
    .firstTh {
      padding-left: 0.2rem;
    }
  }
    }
    .tags {
        background-color: #fff;
        height: 0.9067rem;
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        //   margin-top: -5px;
        margin-top: -1px;
        border-bottom: 3px solid #f7f8fa;
        border-top: 5px solid #f7f8fa;

        &::-webkit-scrollbar {
          width: 0px;
          height: 0px;
        }

        .tag {
          float: left;
          position: relative;
          /*width: 70px;*/
          height: 0.9067rem;
          text-align: center;
          line-height: 34px;
          font-size: 12px;
          color: #333;
          padding: 0 10px;

          &.active:after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
           // width: 30px;
            height: 3px;
            background-color: #f69c2d;
            margin: 0 0.3rem;
          }
        }
      }
  }
</style>



// WEBPACK FOOTER //
// revenueReport.vue?34852955